<template>
  <div id="presentation-dl">
    <div class="row">
      <div class="col-md-4 col-md-offset-0 col-sm-offset-2 col-sm-8"
           v-if="files.spiadi.length > 0">
        <div class="panel panel-gray">
          <div class="panel-heading text-center">
            <h2 class="panel-title"><strong>SPIADI</strong></h2>
          </div>
          <div class="panel-body">
            <ul>
              <link-block v-for="(b, k) in files.spiadi"
                          :key="k"
                          :link="b.link"
                          :description="b.description"
                          :title="b.title"
                          class="fb-gray"
                          :text="b.text"
                          :icon="b.icon">
              </link-block>
            </ul>
          </div>
          <!--div class="panel-footer text-center"
               v-if="files.zips.spiadi.file">
            <a :href="require(`@/assets/${files.zips.spiadi.file}`)"
               :download="files.zips.spiadi.description">
              Tout télécharger
            </a>
          </div-->
        </div>
        <div class="panel panel-gray">
          <div class="panel-heading text-center">
            <h2 class="panel-title"><strong>Annexes</strong></h2>
          </div>
          <div class="panel-body">
            <ul>
              <div v-for="(b, k) in files.annexes"
                   :key="k">
                  <div class="col-xs-12">
                    <link-block :link="b.link"
                                :description="b.description"
                                :title="b.title"
                                class="fb-gray"
                                :text="b.text"
                                :icon="b.icon">
                    </link-block>
                  </div>
              </div>
            </ul>
          </div>
          <!--div class="panel-footer text-center"
               v-if="files.zips.annexes.file">
            <a :href="require(`@/assets/${files.zips.annexes.file}`)"
               :download="files.zips.annexes.description">
              Tout télécharger
            </a>
          </div-->
        </div>
      </div>
      <div class="col-md-8 col-md-offset-0 col-sm-offset-2 col-sm-8">
        <div class="panel panel-bactADI">
          <div class="panel-heading text-center">
            <h2 class="panel-title"><strong>Bact ADI+</strong></h2>
          </div>
          <div class="panel-body">
            <ul>
              <div v-for="(b, k) in files.bactADI"
                   :key="k">
                <div class="col-md-6">
                  <link-block :file="b.file"
                              :link="b.link"
                              :description="b.description"
                              :title="b.title"
                              class="fb-bactADI"
                              :text="b.text"
                              :icon="b.icon">
                  </link-block>
                </div>
                <div v-if="!((k + 1) % 2)" class="clearfix"></div>
              </div>
            </ul>
          </div>
          <!--div class="panel-footer text-center">
            <a :href="require(`@/assets/${files.zips.bactADI.file}`)"
               :download="files.zips.bactADI.description">
              Tout télécharger
            </a>
          </div-->
        </div>
        <div class="panel panel-expADI">
          <div class="panel-heading text-center">
            <h2 class="panel-title"><strong>Exp ADI</strong></h2>
          </div>
          <div class="panel-body">
            <ul>
              <div v-for="(b, k) in files.expADI"
                   :key="k">
                <div class="col-md-6">
                  <link-block :link="b.link"
                              :description="b.description"
                              :title="b.title"
                              class="fb-expADI"
                              :text="b.text"
                              :icon="b.icon">
                  </link-block>
                </div>
                <div v-if="!((k + 1) % 2)" class="clearfix"></div>
              </div>
            </ul>
          </div>
          <!--div class="panel-footer text-center">
            <a :href="require(`@/assets/${files.zips.expADI.file}`)"
               :download="files.zips.expADI.description">
              Tout télécharger
            </a>
          </div-->
        </div>
        <div class="panel panel-reaInfADI">
          <div class="panel-heading text-center">
            <h2 class="panel-title"><strong>Réa/Néo/Dia Inf ADI</strong></h2>
          </div>
          <div class="panel-body">
            <div class="row">
              <ul>
                <div v-for="(b, k) in files.reaInfADI"
                     :key="k">
                  <div class="col-md-6">
                    <link-block :link="b.link"
                                :description="b.description"
                                :title="b.title"
                                :class="`fb-${b.type}`"
                                :text="b.text"
                                :icon="b.icon">
                    </link-block>
                  </div>
                  <div v-if="!((k + 1) % 2)" class="clearfix"></div>
                </div>
              </ul>
            </div>
          </div>
          <!--div class="panel-footer text-center">
            <a :href="require(`@/assets/${files.zips.reaInfADI.file}`)"
               :download="files.zips.reaInfADI.description">
              Tout télécharger
            </a>
          </div-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import linkBlock from '@/components/linkBlock'
import horizontalFeatureBlock from '@/components/horizontalFeatureBlock'
import sc from '@/sc/presentation'

export default {
  name: 'presentation-dl',

  computed: {
    files: function () {
      return sc.files
    }
  },

  components: {
    'link-block': linkBlock,
    'horizontal-feature-block': horizontalFeatureBlock
  }
}
</script>

<style scoped lang="less">
ul {
  padding-left: 1rem;
  padding-right: 1rem;
}
h2.panel-title {
  font-size: 180%;
}
</style>
